import { render, staticRenderFns } from "./transcription-ocr.vue?vue&type=template&id=ba0636fc&scoped=true&lang=pug&"
import script from "./transcription-ocr.vue?vue&type=script&lang=ts&"
export * from "./transcription-ocr.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0636fc",
  null
  
)

export default component.exports